import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl
} from '@angular/forms';

@Component({
  selector: 'dual-checkbox',
  templateUrl: './dual-checkbox.component.html',
  styleUrls: ['./dual-checkbox.component.scss']
})
export class DualCheckboxComponent implements OnInit {
  formGroup: UntypedFormGroup;

  @Input()
  public checked: boolean[] = [false, false];
  @Input()
  public leftText: string;
  @Input()
  public rightText: string;
  @Input()
  public title: string;
  @Input()
  public subtitle: string;
  @Input()
  public isDisabled: boolean;

  @Output()
  public answer = new EventEmitter();

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit() {
    this.formGroup = this.initForm();
  }

  initForm() {
    return this.formBuilder.group({
      answer: new UntypedFormControl('')
    });
  }

  answered(value) {
    if (value.index == 0 && this.checked[0] && this.checked[1]) {
      this.checked[1] = false;
    }
    if (value.index == 1 && this.checked[0] && this.checked[1]) {
      this.checked[0] = false;
    }
    this.answer.emit(this.checked);
  }
}
